(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bmg-discover"] && !Shopify.designMode) return;
  try {
    
function initialiseBmgDirectories(root) {
  root.querySelectorAll('[data-brand-directory]').forEach(directory => {
    if (directory.dataset.ready) return;
    directory.dataset.ready = 'true';
    const input = directory.querySelector('input');
    const cards = [...directory.querySelectorAll('[data-brand-card]')];
    const count = directory.querySelector('[data-brand-count]');
    const empty = directory.querySelector('[data-brand-empty]');
    const normalise = text => text.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim();
    directory.querySelector('[data-brand-controls]').hidden = false;
    input.addEventListener('input', () => {
      const query = normalise(input.value);
      let visible = 0;
      cards.forEach(card => { const searchable = normalise(card.dataset.brandSearch || card.textContent); card.hidden = !query.split(/\s+/).every(term => searchable.includes(term)); if (!card.hidden) visible++; });
      const index = directory.querySelector('.bmg-brand-index');
      if (index) index.hidden = !!query;
      count.textContent = count.dataset.countTemplate ? count.dataset.countTemplate.replace('__count__', visible).replace('__total__', cards.length) : visible + ' / ' + cards.length;
      empty.hidden = visible !== 0;
    });
  });
}
initialiseBmgDirectories(document);
document.addEventListener('shopify:section:load', event => initialiseBmgDirectories(event.target));
function bmgCalendarFile(event) {
  const escape = text => String(text).replace(/\\/g, '\\\\').replace(/\r?\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');
  const end = new Date(event.end + 'T00:00:00Z');
  end.setUTCDate(end.getUTCDate() + 1);
  const endDate = end.toISOString().slice(0, 10).replace(/-/g, '');
  const stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  const uid = event.start + '-' + event.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0, 90) + '@bmg.solar';
  const lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//BMG Solar//Industry calendar//EN', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT', 'UID:' + uid, 'DTSTAMP:' + stamp, 'DTSTART;VALUE=DATE:' + event.start.replace(/-/g, ''), 'DTEND;VALUE=DATE:' + endDate, 'SUMMARY:' + escape(event.name), 'LOCATION:' + escape(event.location), 'DESCRIPTION:' + escape(event.info + '\n' + event.url), 'URL:' + event.url, 'END:VEVENT', 'END:VCALENDAR'];
  // RFC 5545 folds at octet boundaries without splitting a UTF-8 character.
  const encoder = new TextEncoder();
  const fold = line => {
    let result = '', length = 0;
    for (const char of line) {
      const bytes = encoder.encode(char).length;
      if (length + bytes > 75) { result += '\r\n '; length = 1; }
      result += char; length += bytes;
    }
    return result;
  };
  return lines.map(fold).join('\r\n') + '\r\n';
}
function initialiseBmgEventCalendars(root) {
  const normalise = value => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim();
  root.querySelectorAll('[data-bmg-calendar]').forEach(calendar => {
    if (calendar.dataset.ready) return;
    calendar.dataset.ready = 'true';
    const text = JSON.parse(calendar.dataset.calendarText);
    const form = calendar.querySelector('[data-event-controls]');
    const rows = [...calendar.querySelectorAll('[data-event-row]')];
    const fields = Object.fromEntries([...form.querySelectorAll('[data-filter]')].map(field => [field.dataset.filter, field]));
    const todayDate = new Date();
    const today = [todayDate.getFullYear(), String(todayDate.getMonth() + 1).padStart(2, '0'), String(todayDate.getDate()).padStart(2, '0')].join('-');
    const searchable = new Map(rows.map(row => [row, normalise(row.textContent)]));
    const pagers = [...calendar.querySelectorAll('[data-event-pagination]')];
    const count = calendar.querySelector('[data-event-count]');
    count.tabIndex = -1;
    const mobile = window.matchMedia('(max-width:650px)');
    const defaults = {status:'upcoming', year:'', month:'', location:'', subject:'', search:''};
    let page = 0, inputTimer;
    const readUrl = () => {
      const params = new URL(window.location.href).searchParams;
      Object.entries(fields).forEach(([key, field]) => {
        const val = params.get('event_' + key) ?? defaults[key];
        field.value = field.tagName === 'SELECT' && ![...field.options].some(option => option.value === val) ? defaults[key] : val;
      });
      page = Math.max(0, (Number(params.get('event_page')) || 1) - 1);
    };
    const writeUrl = mode => {
      const url = new URL(window.location.href);
      Object.entries(fields).forEach(([key, field]) => {
        if (field.value === defaults[key]) url.searchParams.delete('event_' + key);
        else url.searchParams.set('event_' + key, field.value);
      });
      if (page) url.searchParams.set('event_page', page + 1); else url.searchParams.delete('event_page');
      if (url.href !== window.location.href) history[mode + 'State'](null, '', url);
    };
    const update = (resetPage = true, historyMode = 'replace') => {
      if (resetPage) page = 0;
      const pageSize = mobile.matches ? 6 : 12;
      const query = normalise(fields.search.value);
      const matches = rows.filter(row => {
        const e = row.dataset;
        const statusMatch = fields.status.value === 'all' || (fields.status.value === 'past' ? e.end < today : e.end >= today);
        const { start, end } = e, year = fields.year.value, month = fields.month.value;
        let periodMatch = true;
        if (year && month) periodMatch = start <= year + '-' + month + '-31' && end >= year + '-' + month + '-01';
        else if (year) periodMatch = start <= year + '-12-31' && end >= year + '-01-01';
        else if (month) periodMatch = [...new Set([start.slice(0,4), end.slice(0,4)])].some(y => start <= y + '-' + month + '-31' && end >= y + '-' + month + '-01');
        return statusMatch && periodMatch && (!fields.location.value || e.country === fields.location.value) && (!fields.subject.value || e.topics.split(';').map(normalise).includes(normalise(fields.subject.value))) && (!query || searchable.get(row).includes(query));
      });
      const pages = Math.max(1, Math.ceil(matches.length / pageSize));
      page = Math.max(0, Math.min(Math.floor(page), pages - 1));
      const visible = new Set(matches.slice(page * pageSize, (page + 1) * pageSize));
      rows.forEach(row => { row.hidden = !visible.has(row); });
      count.textContent = matches.length ? (page * pageSize + 1) + '–' + Math.min((page + 1) * pageSize, matches.length) + ' ' + text.calendar_of + ' ' + matches.length + ' ' + (matches.length === 1 ? text.event_singular : text.event_plural) : text.event_empty;
      calendar.querySelector('[data-event-empty]').hidden = matches.length !== 0;
      calendar.querySelector('table').hidden = matches.length === 0;
      pagers.forEach(pager => {
        pager.hidden = matches.length <= pageSize;
        pager.querySelector('[data-event-previous]').disabled = page === 0;
        pager.querySelector('[data-event-next]').disabled = page + 1 >= pages;
        pager.querySelector('[data-event-page]').textContent = text.calendar_page + ' ' + (page + 1) + ' ' + text.calendar_of + ' ' + pages;
      });
      if (historyMode) writeUrl(historyMode);
    };
    form.hidden = false;
    form.addEventListener('submit', event => {event.preventDefault(); update(true, 'push');});
    form.addEventListener('input', event => {
      if (event.target !== fields.search) return;
      clearTimeout(inputTimer); inputTimer = setTimeout(() => update(true), 160);
    });
    form.addEventListener('change', () => {clearTimeout(inputTimer); update(true, 'push');});
    form.addEventListener('reset', () => {clearTimeout(inputTimer); setTimeout(() => update(true, 'push'), 0);});
    pagers.forEach(pager => {
      const turn = direction => {
        page += direction; update(false, 'push');
        count.scrollIntoView({block:'start'}); count.focus({preventScroll:true});
      };
      pager.querySelector('[data-event-previous]').addEventListener('click', () => turn(-1));
      pager.querySelector('[data-event-next]').addEventListener('click', () => turn(1));
    });
    rows.forEach(row => {
      const button = row.querySelector('[data-event-download]');
      button.hidden = false;
      button.addEventListener('click', () => {
        const name = row.querySelector('[data-label="Event"] strong').textContent.trim();
        const file = bmgCalendarFile({start:row.dataset.start, end:row.dataset.end, name, location:row.querySelector('[data-label="City and country"]').innerText.replace(/\n/g, ', '), url:row.querySelector('[data-label="Organiser"] > a').href, info:text.event_info});
        const url = URL.createObjectURL(new Blob([file], {type:'text/calendar;charset=utf-8'}));
        const a = document.createElement('a'); a.href = url; a.download = name.toLowerCase().replace(/[^a-z0-9]+/g,'-').slice(0,80) + '.ics';
        document.body.append(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(url), 10000);
      });
    });
    window.addEventListener('popstate', () => {readUrl(); update(false, null);});
    mobile.addEventListener('change', () => update(true));
    readUrl(); update(false);
  });
}

function initialiseBmgSignups(root) {
  root.querySelectorAll('[data-bmg-signup]').forEach(form => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const tags = form.querySelector('[data-signup-tags]');
    const preferences = [...form.querySelectorAll('[data-interest]')];
    const updateTags = () => {
      const chosen = preferences.filter(input => input.checked).map(input => input.value);
      tags.value = ['newsletter', 'bmg-insights', ...(chosen.length ? chosen : ['bmg-interest-all'])].join(',');
    };
    form.addEventListener('change', updateTags);
    form.addEventListener('submit', updateTags);
    updateTags();
  });
}

initialiseBmgEventCalendars(document);
initialiseBmgSignups(document);
document.addEventListener('shopify:section:load', event => {
  initialiseBmgEventCalendars(event.target);
  initialiseBmgSignups(event.target);
});

if (!customElements.get('bmg-instagram-feed')) {
  let bmgInstagramPrivacyRequest;
  let bmgInstagramEmbedRequest;
  const bmgLoadInstagramPrivacy = () => {
    if (window.Shopify?.customerPrivacy?.currentVisitorConsent) return Promise.resolve();
    if (!bmgInstagramPrivacyRequest) {
      bmgInstagramPrivacyRequest = new Promise((resolve, reject) => {
        const deadline = Date.now() + 5000;
        const load = () => {
          if (typeof window.Shopify?.loadFeatures !== 'function') {
            if (Date.now() < deadline) { setTimeout(load, 100); return; }
            reject(new Error('Privacy API unavailable')); return;
          }
          const timeout = setTimeout(() => reject(new Error('Privacy API timed out')), 5000);
          window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
            clearTimeout(timeout);
            if (error || !window.Shopify?.customerPrivacy?.currentVisitorConsent) reject(new Error('Privacy API unavailable'));
            else resolve();
          });
        };
        load();
      }).catch(error => { bmgInstagramPrivacyRequest = null; throw error; });
    }
    return bmgInstagramPrivacyRequest;
  };
  const bmgLoadInstagramEmbed = () => {
    if (typeof window.instgrm?.Embeds?.process === 'function') return Promise.resolve();
    if (!bmgInstagramEmbedRequest) {
      bmgInstagramEmbedRequest = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        let timeout;
        const fail = () => { clearTimeout(timeout); script.remove(); reject(new Error('Instagram unavailable')); };
        script.src = 'https://www.instagram.com/embed.js';
        script.async = true;
        script.addEventListener('load', () => {
          clearTimeout(timeout);
          if (typeof window.instgrm?.Embeds?.process === 'function') resolve();
          else fail();
        }, {once:true});
        script.addEventListener('error', fail, {once:true});
        timeout = setTimeout(fail, 12000);
        document.head.append(script);
      }).catch(error => { bmgInstagramEmbedRequest = null; throw error; });
    }
    return bmgInstagramEmbedRequest;
  };
  customElements.define('bmg-instagram-feed', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.host = this.querySelector('[data-instagram-embed]');
      this.status = this.querySelector('[data-instagram-status]');
      this.preferences = this.querySelector('[data-instagram-preferences]');
      this.retry = this.querySelector('[data-instagram-retry]');
      this.generation = (this.generation || 0) + 1;
      this.loading = false;
      this.mounted = false;
      this.failed = false;
      this.near = !('IntersectionObserver' in window);
      this.preferences.hidden = false;
      this.preferences.addEventListener('click', () => this.openPreferences(), {signal});
      this.retry.addEventListener('click', () => { this.failed = false; this.syncConsent(); }, {signal});
      document.addEventListener('visitorConsentCollected', () => { this.failed = false; this.syncConsent(); }, {signal});
      if ('IntersectionObserver' in window) {
        this.viewportObserver = new IntersectionObserver(entries => {
          this.near = entries.some(entry => entry.isIntersecting);
          this.syncConsent();
        }, {rootMargin:'240px 0px'});
        this.viewportObserver.observe(this);
      }
      bmgLoadInstagramPrivacy().then(() => { if (this.isConnected) this.syncConsent(); }).catch(() => {
        if (this.isConnected) this.setStatus(this.dataset.errorText);
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.viewportObserver?.disconnect();
      this.clearEmbed();
    }
    hasConsent() {
      try { return window.Shopify?.customerPrivacy?.currentVisitorConsent()?.marketing === 'yes'; }
      catch { return false; }
    }
    setStatus(text) {
      this.status.textContent = text;
      this.status.hidden = !text;
    }
    clearEmbed() {
      this.generation++;
      this.frameObserver?.disconnect();
      clearTimeout(this.frameTimeout);
      this.host.replaceChildren();
      this.host.hidden = true;
      this.loading = false;
      this.mounted = false;
      this.removeAttribute('aria-busy');
    }
    syncConsent() {
      if (!this.isConnected) return;
      if (!this.hasConsent()) {
        this.clearEmbed();
        this.failed = false;
        this.retry.hidden = true;
        this.setStatus(this.dataset.consentText);
        return;
      }
      if (this.mounted || this.loading || this.failed) return;
      this.retry.hidden = true;
      if (this.near) this.loadEmbed();
      else this.setStatus(this.dataset.waitingText);
    }
    async openPreferences() {
      this.preferences.disabled = true;
      const deadline = Date.now() + 5000;
      try {
        while (typeof window.privacyBanner?.showPreferences !== 'function' && Date.now() < deadline && this.isConnected) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        if (!this.isConnected) return;
        if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Cookie preferences unavailable');
        await window.privacyBanner.showPreferences();
      } catch {
        if (this.isConnected) this.setStatus(this.dataset.preferencesError);
      } finally {
        if (this.isConnected) this.preferences.disabled = false;
      }
    }
    async loadEmbed() {
      if (!this.isConnected || !this.near || !this.hasConsent() || this.loading || this.mounted) return;
      const generation = ++this.generation;
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.setStatus(this.dataset.loadingText);
      try {
        const profile = new URL(this.dataset.profileUrl);
        if (profile.protocol !== 'https:' || !['instagram.com','www.instagram.com'].includes(profile.hostname) || !/^\/[A-Za-z0-9._]+\/?$/.test(profile.pathname)) throw new Error('Unsupported Instagram profile');
        await bmgLoadInstagramEmbed();
        if (!this.isConnected || generation !== this.generation || !this.hasConsent()) return;
        if (!this.near) { this.loading = false; this.removeAttribute('aria-busy'); this.setStatus(this.dataset.waitingText); return; }
        const quote = document.createElement('blockquote');
        quote.className = 'instagram-media';
        quote.dataset.instgrmPermalink = profile.href;
        quote.dataset.instgrmVersion = '14';
        quote.style.cssText = 'width:100%;max-width:540px;min-width:0;margin:0';
        this.frameObserver = new MutationObserver(() => {
          if (!this.hasConsent()) { this.syncConsent(); return; }
          const frames = this.host.querySelectorAll('iframe');
          frames.forEach(frame => { frame.title = this.dataset.frameTitle; });
          if (frames.length) {
            clearTimeout(this.frameTimeout);
            this.mounted = true;
            this.loading = false;
            this.removeAttribute('aria-busy');
            this.setStatus('');
          }
        });
        this.frameObserver.observe(this.host, {childList:true,subtree:true});
        this.host.replaceChildren(quote);
        this.host.hidden = false;
        this.frameTimeout = setTimeout(() => {
          if (generation !== this.generation || this.mounted) return;
          this.clearEmbed();
          this.failed = true;
          this.retry.hidden = false;
          this.setStatus(this.dataset.errorText);
        }, 15000);
        window.instgrm.Embeds.process();
      } catch {
        if (!this.isConnected || generation !== this.generation) return;
        this.clearEmbed();
        this.failed = true;
        this.retry.hidden = false;
        this.setStatus(this.dataset.errorText);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bmg-services-page"]) return;
  try {
    
if (!customElements.get('bmg-enquiry-subject')) {
  customElements.define('bmg-enquiry-subject', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      const select = this.querySelector('select');
      const field = this.querySelector('[data-bmg-custom-subject]');
      const input = field.querySelector('input');
      const update = () => {
        const other = select.selectedOptions[0]?.hasAttribute('data-bmg-other') || false;
        field.hidden = !other;
        input.disabled = !other;
        input.required = other;
      };
      select.addEventListener('change', update);
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
